(function () {

  // =============================================================
  // PRODUCT QUANTITY LIMITS CONFIGURATION
  // =============================================================
  // Add or edit products below. For each product you need:
  //   - The product ID (found in Shopify admin URL: /products/PRODUCT_ID)
  //   - All variant IDs for that product (found in /products/PRODUCT_ID/variants/VARIANT_ID)
  //   - The maximum quantity allowed per order
  //   - A custom error message shown when the limit is exceeded
  //
  // Example entry:
  //   1234567890123: {
  //     variantIds: [11111111111111, 22222222222222],
  //     maxQty: 2,
  //     errorMsg: 'Sorry, you can only purchase a maximum of 2 of this item.'
  //   },
  // =============================================================

  const PRODUCT_LIMITS = {

    6747077410929: {
      variantIds: [39828397686897],
      maxQty: 4,
      errorMsg: 'Sorry, you can only purchase a maximum of 4 of this item.'
    },

    // --- ADD NEW PRODUCTS BELOW THIS LINE ---
    // PRODUCT_ID: {
    //   variantIds: [VARIANT_ID_1, VARIANT_ID_2],
    //   maxQty: N,
    //   errorMsg: 'Sorry, you can only purchase a maximum of N of this item.'
    // },

  };

  // =============================================================
  // DO NOT EDIT BELOW THIS LINE
  // =============================================================

  const originalFetch = window.fetch.bind(window);
  let pendingQty = {};

  function getLimitForVariant(variantId) {
    variantId = parseInt(variantId);
    for (const [productId, config] of Object.entries(PRODUCT_LIMITS)) {
      if (config.variantIds.includes(variantId)) {
        return { productId: parseInt(productId), maxQty: config.maxQty, errorMsg: config.errorMsg };
      }
    }
    return null;
  }

  function getCartQtyForProduct(productId) {
    return originalFetch('/cart.js')
      .then(r => r.json())
      .then(cart =>
        cart.items
          .filter(i => i.product_id === productId)
          .reduce((sum, i) => sum + i.quantity, 0)
      );
  }

  // --- Show a single error message, suppressing Debut's native error display ---
  function showError(msg) {
    // Permanently suppress Debut's error wrapper so it can never show alongside ours
    const debutError = document.querySelector('[data-cart-error-message-wrapper]');
    if (debutError) {
      debutError.classList.add('hide');
      // Re-hide it if Debut tries to unhide it after us
      const observer = new MutationObserver(() => {
        if (!debutError.classList.contains('hide')) {
          debutError.classList.add('hide');
        }
      });
      observer.observe(debutError, { attributes: true, attributeFilter: ['class'] });
      // Stop observing after 6 seconds
      setTimeout(() => observer.disconnect(), 6000);
    }

    // Find the quantity input and insert error directly after it
    const qtyInput = document.querySelector('.product-form__quantity')
      || document.querySelector('.quantity-selector')
      || document.querySelector('[name="quantity"]');

    const anchor = qtyInput
      ? (qtyInput.closest('.product-form__item') || qtyInput.parentElement)
      : (document.querySelector('form[action="/cart/add"]')
        || document.querySelector('form[action="/cart"]')
        || document.body);

    let el = document.getElementById('qty-limit-error');
    if (!el) {
      el = document.createElement('p');
      el.id = 'qty-limit-error';
      el.style.cssText = 'color:red;font-weight:bold;margin:8px 0;font-size:14px;';
      anchor.appendChild(el);
    }

    el.textContent = msg;
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(() => { el.textContent = ''; }, 5000);
  }

  function getLimitedItemFromBody(bodyStr) {
    if (!bodyStr) return null;

    try {
      const body = JSON.parse(bodyStr);
      if (body.items && Array.isArray(body.items)) {
        for (const item of body.items) {
          const limit = getLimitForVariant(item.id);
          if (limit) return { ...limit, requestedQty: parseInt(item.quantity) || 1 };
        }
        return null;
      }
      if (body.id) {
        const limit = getLimitForVariant(body.id);
        if (limit) return { ...limit, requestedQty: parseInt(body.quantity) || 1 };
      }
      return null;
    } catch (e) {}

    try {
      const params = new URLSearchParams(bodyStr);
      const id = params.get('id');
      const quantity = parseInt(params.get('quantity')) || 1;
      if (id) {
        const limit = getLimitForVariant(id);
        if (limit) return { ...limit, requestedQty: quantity };
      }
    } catch (e) {}

    return null;
  }

  function checkAndBlock(limited, proceedFn, blockFn) {
    const { productId, maxQty, errorMsg, requestedQty } = limited;
    getCartQtyForProduct(productId).then(currentQty => {
      const effective = currentQty + (pendingQty[productId] || 0);
      if (effective + requestedQty > maxQty) {
        showError(errorMsg);
        blockFn();
      } else {
        pendingQty[productId] = (pendingQty[productId] || 0) + requestedQty;
        proceedFn(() => { pendingQty[productId] -= requestedQty; });
      }
    });
  }

  // --- INTERCEPT XMLHttpRequest (Debut uses jQuery $.ajax = XHR) ---
  const OriginalXHR = window.XMLHttpRequest;
  window.XMLHttpRequest = function () {
    const xhr = new OriginalXHR();
    const originalOpen = xhr.open.bind(xhr);
    const originalSend = xhr.send.bind(xhr);
    let requestUrl = '';

    xhr.open = function (method, url) {
      requestUrl = url;
      return originalOpen.apply(xhr, arguments);
    };

    xhr.send = function (body) {
      if (typeof requestUrl === 'string' && requestUrl.includes('/cart/add')) {
        const limited = getLimitedItemFromBody(body);
        if (limited) {
          checkAndBlock(
            limited,
            function (releaseFn) {
              // Allow the request through
              xhr.addEventListener('load', releaseFn);
              xhr.addEventListener('error', releaseFn);
              originalSend(body);
            },
            function () {
              // Silently abort — do NOT simulate a 422 so Debut's error
              // handler never fires and we avoid the duplicate message.
              // Our showError() above already displayed the message.
              xhr.abort();
            }
          );
          return;
        }
      }
      return originalSend(body);
    };

    return xhr;
  };

  // --- INTERCEPT fetch (safety net for non-jQuery add-to-cart calls) ---
  window.fetch = function (url, options) {
    const urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    if (urlStr.includes('/cart/add')) {
      const limited = getLimitedItemFromBody((options && options.body) || '');
      if (limited) {
        return new Promise((resolve, reject) => {
          checkAndBlock(
            limited,
            function (releaseFn) {
              originalFetch(url, options)
                .then(res => { releaseFn(); resolve(res); })
                .catch(err => { releaseFn(); reject(err); });
            },
            function () {
              // Silently reject without triggering Debut's error handler
              reject({ message: limited.errorMsg, status: 422 });
            }
          );
        });
      }
    }
    return originalFetch(url, options);
  };

  // --- CART PAGE: Block quantity input changes that exceed the limit ---
  function initCartPage() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.cart__qty-input')) return;
      const newQty = parseInt(e.target.value) || 0;

      const row = e.target.closest('tr');
      if (!row) return;
      const link = row.querySelector('a[href*="/products/"]');
      if (!link) return;

      originalFetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          for (const [productId, config] of Object.entries(PRODUCT_LIMITS)) {
            const match = cart.items.find(
              item => item.product_id === parseInt(productId) && link.href.includes(item.handle)
            );
            if (match && newQty > config.maxQty) {
              e.target.value = config.maxQty;
              showError(config.errorMsg);
              break;
            }
          }
        });
    });
  }

  // --- PRODUCT PAGE: Non-Ajax form submit fallback ---
  function initProductPage() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;
    const limited = getLimitForVariant(variantInput.value);
    if (!limited) return;

    form.addEventListener('submit', function handler(e) {
      const qtyInput = form.querySelector('[name="quantity"]');
      const requestedQty = parseInt(qtyInput && qtyInput.value) || 1;
      e.preventDefault();
      e.stopImmediatePropagation();

      getCartQtyForProduct(limited.productId).then(currentQty => {
        const effective = currentQty + (pendingQty[limited.productId] || 0);
        if (effective + requestedQty > limited.maxQty) {
          showError(limited.errorMsg);
        } else {
          form.removeEventListener('submit', handler, true);
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductPage();
    initCartPage();
  });

})();
